import React from 'react';
import ActionBar from './ActionBar';
import AddImageAction from './Actions/AddImageAction';
import { ImageListType } from 'react-images-uploading';
import { JobModel } from '../NewsfeedModels';
import ShareJobAction from './Actions/ShareJobAction/ShareJobAction';
import ShareProviderAction from './Actions/ShareProviderAction/ShareProviderAction';
import IProvider from '../../../../models/Providers/IProvider';

interface IProps {
    setImages: (imageList: never[]) => void;
    images: ImageListType;
    setJob: (x: JobModel) => void;
    setProvider: (x: IProvider) => void;
}

export default function CommentActionBar({ setImages, images, setJob, setProvider }: IProps) {
    //unless you do your own shenanigans, make the return component an ActionButton component
    const actions = [
        <AddImageAction setImages={setImages} images={images} />,
        <ShareJobAction setJob={setJob} />,
        <ShareProviderAction setProvider={setProvider} />,
    ];

    return <ActionBar actions={actions} />;
}
